import { ComponentProps } from "react";
import { Root, Fallback, Image } from "@radix-ui/react-avatar";

import { cn } from "../../../lib/utils";

function Avatar({ className, ...props }: ComponentProps<typeof Root>) {
  return (
    <Root
      data-slot="avatar"
      className={cn("relative flex w-8 h-8 shrink-0 overflow-hidden rounded-full", className)}
      {...props}
    />
  );
}

function AvatarImage({ className, ...props }: ComponentProps<typeof Image>) {
  return <Image data-slot="avatar-image" className={cn("aspect-square w-full", className)} {...props} />;
}

function AvatarFallback({ className, ...props }: ComponentProps<typeof Fallback>) {
  return (
    <Fallback
      data-slot="avatar-fallback"
      className={cn("bg-muted flex size-full items-center justify-center rounded-full", className)}
      {...props}
    />
  );
}

export { Avatar, AvatarImage, AvatarFallback };
